import { useInView } from "react-hook-inview";

import clsx from "clsx";
import styles from "./C249_FacultyProfileCarousel.module.scss";

import { NextContentfulImage } from "@components/Image";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Cta from "../Cta/Cta";

import RichTextDisplay from "@components/RichTextDisplay/RichTextDisplay";
import { TypeFacultyProfileExtendedFields } from "@customTypes/contentful";

const FacultyProfileSolo = (props: {
  content: TypeFacultyProfileExtendedFields & {
    profilePictureDescription: string;
    url?: string;
    nationality?: string;
  };
  lightbox?: boolean;
}) => {
  const { content, lightbox } = props;
  const {
    academicFocus,
    associatedPrograms,
    careerHighlight,
    experience,
    experienceTinyMce,
    profilePicture,
    profilePictureDescription,
    profileName,
    nationality,
    optionalCtaOne,
    optionalCtaTwo,
    recentClients,
    role,
    url,
    showSubHeading = true,
  } = content;
  const [ref] = useInView({
    threshold: 0,
    unobserveOnEnter: true,
  });

  return (
    <div
      className={clsx(
        "component",
        styles["faculty-profile-carousel"],
        "faculty-profile-carousel",
        lightbox && styles["full-profile-container"]
      )}
    >
      <div className={styles.wrapper}>
        <div className={styles["profile-wrapper"]}>
          <div className={styles["pw-inner-wrapper"]}>
            <div className={styles["image-and-text-wrapper"]}>
              <div className={styles["image-wrapper"]} ref={ref}>
                <div className={styles.image}>
                  {profilePicture && (
                    <NextContentfulImage
                      src={profilePicture as unknown as string}
                      alt={profilePictureDescription || profileName}
                      fill
                    />
                  )}
                </div>
              </div>
              <div className={styles["text-wrapper"]}>
                {profileName && (
                  <h3 className={styles["profile-name"]}>{profileName}</h3>
                )}
                {role && <p className="role">{role}</p>}
                {associatedPrograms && (
                  <>
                    <p
                      className={clsx(
                        styles["programme-type-label"],
                        styles["sub-heading"]
                      )}
                    >
                      Associated Programmes
                    </p>
                    <p className={styles["programme-type"]}>
                      {associatedPrograms}
                    </p>
                  </>
                )}
              </div>
            </div>
            <div className={styles["profile-details"]}>
              <div className={styles["button-wrapper"]}>
                {url && (
                  <Cta
                    type="tertiary"
                    url={url}
                    linkText="View full profile"
                    icon="icon-arrow"
                  />
                )}
              </div>
              <PerfectScrollbar className={styles["pd-inner-wrapper"]}>
                <div className={styles["overflow-container"]}>
                  {careerHighlight && (
                    <>
                      {showSubHeading && (
                        <p className={styles["sub-heading"]}>
                          Career highlight
                        </p>
                      )}
                      <p>{careerHighlight}</p>
                      <span className={styles["dividing-line"]}></span>
                    </>
                  )}

                  {nationality && (
                    <>
                      {showSubHeading && (
                        <p className={styles["sub-heading"]}>Nationality</p>
                      )}
                      {nationality && <p>{nationality}</p>}
                    </>
                  )}

                  {academicFocus && (
                    <>
                      {showSubHeading && (
                        <p className={styles["sub-heading"]}>Academic Focus</p>
                      )}
                      <p>{academicFocus}</p>
                    </>
                  )}

                  {recentClients && (
                    <>
                      {showSubHeading && (
                        <p className={styles["sub-heading"]}>Recent Clients</p>
                      )}
                      <p>{recentClients}</p>
                    </>
                  )}

                  {(experience || experienceTinyMce) && (
                    <>
                      {showSubHeading && (
                        <p className={styles["sub-heading"]}>Experience</p>
                      )}
                      <RichTextDisplay
                        richText={experience}
                        tinyMceRichText={experienceTinyMce}
                      />
                    </>
                  )}

                  {optionalCtaOne && (
                    <>
                      <br />
                      <br />
                      <Cta
                        type="tertiary"
                        url={optionalCtaOne?.fields?.url}
                        linkText={optionalCtaOne?.fields?.linkText}
                        openInNewTab={optionalCtaOne?.fields?.openInNewTab}
                        icon="icon-arrow"
                      />
                    </>
                  )}

                  {optionalCtaTwo && (
                    <>
                      <br />
                      <br />
                      <Cta
                        type="tertiary"
                        url={optionalCtaTwo?.fields?.url}
                        linkText={optionalCtaTwo?.fields?.linkText}
                        openInNewTab={optionalCtaTwo?.fields?.openInNewTab}
                        icon="icon-arrow"
                      />
                    </>
                  )}

                  {url && (
                    <div className={styles.bottom}>
                      <Cta
                        type="tertiary"
                        url={url}
                        linkText="View full profile"
                        icon="icon-arrow"
                      />
                    </div>
                  )}
                </div>
              </PerfectScrollbar>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacultyProfileSolo;
